import {memo} from 'react'
import {PopoverText} from '../../../../components/Popover/Popover'
import dateformat from 'src/utils/dateformat'
import { useLogSAPTypes } from 'src/hooks/useLogSAPTypes'

export interface RowDataProps {
  showPreview: (p1: string, p2: any) => void
  items: {
    request?: string
    ip_response?: string
    response?: string
    request_type?: string
    created_at?: string
    updated_at?: string
    message?: string
    status?: string
  }[]
  rowNumber: number
}

// eslint-disable-next-line react/display-name
export const RowData = memo(({items, rowNumber, showPreview}: RowDataProps) => {
  const {options: logTypes} = useLogSAPTypes()

  const setRequestTypeLabel = (val: string) => {
    const log = logTypes.find((log: any) => log?.value == val);
    return log ? log.label : ''
  }

  return (
    <>
      {items.map((item: any, index: any) => (
        <tr key={item?.id ?? index}>
          <td>{index + 1 + rowNumber}</td>
          <td>{item?.transaction_number ?? '-'}</td>
          <td>
            <a className='cursor-pointer hover-underline' href='javascript:void(0)' onClick={ () => showPreview('Request', item?.request) }>
              {(item?.request ?? '-').substr(0, 20)}
            </a>
          </td>
          <td>
            <PopoverText
              content={item?.ip_response ?? '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>
            <a className='cursor-pointer hover-underline' href='javascript:void(0)' onClick={ () => showPreview('Response', item?.response) }>
            {(item?.response ?? '-').substr(0, 20)}
            </a>
          </td>
          <td>
            <PopoverText
              content={setRequestTypeLabel(item?.request_type)}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{dateformat(item?.created_at, {showtime: true})}</td>
          <td>{dateformat(item?.updated_at, {showtime: true})}</td>
          <td>{item?.message ?? '-'}</td>
          <td>{item?.status ?? '-'}</td>
        </tr>
      ))}
    </>
  )
})
